import { render } from "./ThemeManagement.vue?vue&type=template&id=135bc5f1&scoped=true"
import script from "./ThemeManagement.vue?vue&type=script&lang=js"
export * from "./ThemeManagement.vue?vue&type=script&lang=js"

import "./ThemeManagement.vue?vue&type=style&index=0&id=135bc5f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-135bc5f1"]])

export default __exports__